// i18n ignore
import { ENABLE_EMAIL_SETTING, HAS_EMAIL_SERVICE } from '@/config/constant';
import { emailSettingApi } from '@/services';
import { safeAsync } from './types';
/**
 * 生成邮件 useEmail 的类型定义
 */
function generateEmailDts(emailList) {
    const hasEmailConfig = emailList && emailList.length > 0;
    // 生成 from 字段的类型
    const fromType = hasEmailConfig
        ? emailList.map(e => `'${e.id}'`).join(' | ')
        : undefined;
    // 生成 from 字段的注释
    const fromComment = hasEmailConfig
        ? emailList.map(e => `${e.id}: ${e.name}`).join('，')
        : '';
    // 生成 from 字段（可选）
    const fromField = fromType
        ? `      /** 发件邮箱配置ID（可选）（${fromComment}） */
      from?: ${fromType};`
        : '';
    return `
  /**
   * 邮件通知（依赖应用配置）
   * @example
   * \`\`\`typescript
   * import { useEmail } from '@wujibase/wuji';
   * const email = useEmail();
   * await email.send({
   *   to: 'user1,user2',
   *   title: '通知标题',
   *   content: '<p>通知内容</p>'
   * });
   * \`\`\`
   */
  export function useEmail(): {
    /**
     * 发送邮件
     */
    send(params: {
${fromField}
      /** 收件人（多个用逗号/分号分隔） */
      to: string;
      /** 邮件主题 */
      title: string;
      /** 邮件内容（HTML 格式） */
      content: string;
      /** 抄送（可选） */
      cc?: string;
      /** 密送（可选） */
      bcc?: string;
    }): Promise<void>;
  };`;
}
/**
 * 邮件 DTS 注入器
 */
export const emailInjector = {
    placeholder: '/** inject-email-dts */',
    async generate(projectId) {
        // 如果未启用邮件服务，不注入
        if (!ENABLE_EMAIL_SETTING || !HAS_EMAIL_SERVICE) {
            return '';
        }
        // 获取应用的邮箱配置列表
        const emailList = await safeAsync(() => emailSettingApi.fetchEmailList(projectId), [], '获取邮箱配置列表失败');
        return generateEmailDts(emailList);
    },
};
// 导出给单元测试使用
export { generateEmailDts };
